import { render, staticRenderFns } from "./ReferralStatusWiseCount.vue?vue&type=template&id=66743360&"
import script from "./ReferralStatusWiseCount.vue?vue&type=script&lang=ts&"
export * from "./ReferralStatusWiseCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports